import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';

export default class StompService {
    constructor(wsUrl) {
        this.wsUrl = wsUrl;
        this.stompClient = null;
        this.subscriptions = new Map();
        this.reconnectInterval = 3000;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
    }

    connect() {
        const socket = new SockJS(this.wsUrl);
        this.stompClient = Stomp.over(socket);

        this.stompClient.connect(
            {},
            frame => this.onConnectSuccess(frame),
            error => this.onConnectError(error)
        );
    }

    onConnectSuccess(frame) {
        this.reconnectAttempts = 0;
        // 自动重新订阅
        for (const [topic, callback] of this.subscriptions.entries()) {
            this.subscribe(topic, callback);
        }
    }

    onConnectError(error) {
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts++;
            setTimeout(() => this.connect(), this.reconnectInterval);
        }
    }

    subscribe(topic, callback) {
        if (this.stompClient?.connected) {
            const sub = this.stompClient.subscribe(topic, message => {
                try {
                    const data = JSON.parse(message.body);
                    callback(data);
                } catch (e) {
                }
            });
            this.subscriptions.set(topic, callback);
            return sub;
        } else {
            this.subscriptions.set(topic, callback);
        }
    }

    send(destination, payload) {
        if (this.stompClient?.connected) {
            this.stompClient.send(destination, {}, JSON.stringify(payload));
        } else {
        }
    }

    disconnect() {
        if (this.stompClient) {
            this.subscriptions.clear();
            this.stompClient.disconnect(() => {
            });
        }
    }
}
